import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { AppComponentClass } from '../../shared/service/AppComponent.class';
import { Smtp, SmtpForm } from '../../setting/model/model.class';
import { FormGroup, FormBuilder } from '@angular/forms';
import { SPSmtpService } from '../../profile/profile.service';
import { Router } from '@angular/router';
import { MatSnackBar, MatDialog } from '@angular/material';
import { TestemailComponent } from '../../shared/testemail/testemail.component';
@Component({
  selector: 'app-smtp',
  templateUrl: './smtp.component.html',
  styleUrls: ['./smtp.component.css']
})
export class SmtpComponent extends AppComponentClass<Smtp, SmtpForm> {

  key: number;
  form: FormGroup;

  @Output() public smtpdata = new EventEmitter<any>();
  submitted: boolean = false;
  constructor(protected data: SPSmtpService, protected router: Router, protected fb: FormBuilder, protected msg: MatSnackBar, public dialog: MatDialog) {
    super(data, router, fb, msg);
    this.key = parseInt(sessionStorage.getItem('iduser'));
    this.cdata = new SmtpForm(null);
    this.form = this.cdata.makeform(this.fb);
  }

  ngOnInit(): void {

    this.data.getService().subscribe(res => {

      if (res != null) {
        this.keyfield = res[0].id;
        this.cdata = new SmtpForm(res[0]);
        this.form = this.cdata.makeform(this.fb);
        this.smtpdata.emit(this.cdata);
      }
      else {
        this.keyfield = -1;
        this.cdata = new SmtpForm(null);
        this.form = this.cdata.makeform(this.fb);
        this.smtpdata.emit(this.cdata);
      }
    },
      err => {
        this.keyfield = -1;
        this.cdata = new SmtpForm(null);
        this.form = this.cdata.makeform(this.fb);
        this.smtpdata.emit(this.cdata);
      });
  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  onSubmit() {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }
    if (this.cdata.saveForm(this.form)) {
      console.log(this.cdata);

      this.smtpdata.emit(this.cdata);
      if (this.keyfield == -1) {
        this.data.saveService(JSON.stringify(this.cdata)).subscribe(rs => {
          this.openSnackBar("Data is added successfully", "Clear");
          this.data.getService().subscribe(rss => {
            console.log(rss);
            this.keyfield = rss[0].id;
          });
        });
      }
      else {
        this.data.updateService(JSON.stringify(this.cdata), this.keyfield).subscribe(rs => {
          this.openSnackBar("Data is updated successfully", "Clear");
        });
      }
    }
  }

  onReset() {
    this.data.deleteService(this.keyfield).subscribe(res => {

      this.keyfield = -1;
      this.cdata = new SmtpForm(null);
      this.form = this.cdata.makeform(this.fb);
      this.openSnackBar("SMTP setting reset successfully", "Clear");
    });
  }

  TestEmail() {
    const dialogRef = this.dialog.open(TestemailComponent, {
      width: '700px',
      data: ''
    });
    dialogRef.afterClosed().subscribe(res => {
      console.log(res);
      if (res != null && res != undefined) {
        this.data.SendTestEmail(JSON.stringify(res)).subscribe(rss => {
          this.openSnackBar(rss.message, "Clear");
        },
          err => {
            this.openSnackBar("Email sending failed.", "Clear");
          });
      }
    });
  }

  onBlurFullname(event: any, key: any) {
    console.log(key)
    let fdata = event.target.value;
    console.log(event.target.value);

    if (key == 1)
      this.cdata.fullname = fdata
    if (key == 2)
      this.cdata.domain = fdata
    if (key == 3)
      this.cdata.username = fdata
    if (key == 4)
      this.cdata.emailid = fdata;
    if (key == 5)
      this.cdata.smtp_port = fdata
    if (key == 6)
      this.cdata.password = fdata
    console.log(this.cdata)
    this.smtpdata.emit({cdata:this.cdata,keyfield:this.keyfield});
  }

  warning()
  {
    if (this.cdata.fullname != this.form.get("fullname").value)
      this.cdata.fullname = this.form.get("fullname").value;
    if (this.cdata.domain != this.form.get("domain").value)
      this.cdata.domain = this.form.get("domain").value;
    if (this.cdata.username != this.form.get("username").value)
      this.cdata.username = this.form.get("username").value;
    if (this.cdata.emailid != this.form.get("emailid").value)
      this.cdata.emailid = this.form.get("emailid").value;
    if (this.cdata.smtp_port != this.form.get("smtp_port").value)
      this.cdata.smtp_port = this.form.get("smtp_port").value;
    if (this.cdata.password != this.form.get("password").value)
      this.cdata.password = this.form.get("password").value;

    this.smtpdata.emit({cdata:this.cdata,keyfield:this.keyfield});
  }

}
